export default __webpack_public_path__ + "static/media/gd.1f93c180.svg";